import React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { Row, Col } from "components/bootstrap";
import {
  RotationStrategySummary,
  RetentionStrategySummary
} from "components/indices/IndexMaintenanceStrategiesSummary";
import { DataTieringSummary, DATA_TIERING_TYPE } from "components/indices/data-tiering";
const IndicesConfiguration = ({ indexSet }) => {
  if (!indexSet.writable) {
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, "Index set is not writable and will not be included in index rotation and retention. It is also not possible to assign it to a stream."));
  }
  const dataTieringConfig = indexSet.data_tiering;
  if (!dataTieringConfig) {
    const rotationConfig = {
      strategy: indexSet.rotation_strategy_class,
      config: indexSet.rotation_strategy
    };
    const retentionConfig = {
      strategy: indexSet.retention_strategy_class,
      config: indexSet.retention_strategy
    };
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(RotationStrategySummary, { config: rotationConfig })), /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(RetentionStrategySummary, { config: retentionConfig, rotationStrategyClass: rotationConfig.strategy })));
  }
  const dataTieringPlugin = PluginStore.exports("dataTiering").find(
    (plugin) => plugin.type === DATA_TIERING_TYPE.HOT_WARM
  );
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(DataTieringSummary, { config: dataTieringConfig })), dataTieringPlugin && /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(dataTieringPlugin.TiersSummary, { config: dataTieringConfig })));
};
export default IndicesConfiguration;
